<template>
  <div>
    <van-row class="turntable_height" style="height: 100vh">
      <van-col span="24" style="height:20%;" @click="turntable_hide"></van-col>
      <van-col span="24" class="turntable_top">

        <van-col span="24" class="turntable_van-tabs">
          <van-tabs v-model="active" @click="active_onclick">
            <van-tab v-for="(v,index) in prizeList" :key="v.id" :title="v.title">
              <van-col span="24" >
                <div class="turntable_wheel">
                  <!-- 中奖图片-->
                  <div class="turntable_checked_img">
                    <img src="../assets/img/turntable_checked2.png" v-if="index"/>
                    <img src="../assets/img/turntable_checked.png" v-else/>
                  </div>
                  <div :class="index ? ' turntable_wheel_pointer2' : 'turntable_wheel_pointer'" @click="beginRotate()"></div>
                  <div :class="index ? ' turntable_wheel_bg2' : 'turntable_wheel_bg'" :style="rotateStyle">
                    <div class="prize-list">
                      <div
                        class="prize-item"
                        v-for="(item,index) in v.gift"
                        :key="index"
                        :style="item.style"
                      >
                        <div class="prize-type">
                          {{item.coin}}
<!--                          <img src="./../assets/img/icon_diamonds.png" style="height:11px;"/>-->
                        </div>
                        <div class="prize-pic">
                          <img :src="item.img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-col>
              <!-- 选择按钮 -->
              <van-col span="20" offset="2" class="turntable_sum_top">
                <van-col span="8" v-for="(num,i) in v.number" :key="i" class="turntable_sum_left" @click="turntable_type_btn(i)">
                  <van-col span="24" :class="turntable_checked === i ? 'turntable_sum_checked_i turntable_sum_type' : 'turntable_sum_type turntable_sum_type'">
                    <van-col span="24" class="turntable_sum_type_frequency">转{{ num }}次</van-col>
                  </van-col>
                </van-col>
              </van-col>
              <van-col span="24" class="turntable_sum_type_reward" >{{ v.introduce[turntable_checked] }}</van-col>
            </van-tab>
          </van-tabs>
        </van-col>
        <!-- 余额-->
        <van-col span="22" offset="1" class="turntable_balance">
          <van-col span="3" class="turntable_balance_name">余额:</van-col>
          <van-col span="21" class="turntable_balance_img">
            <span>{{ coin }} {{ diamonds_name }}</span>
            <div class="turntable_balance_btn" @click="recharge_btn">充值 </div>
            <div class="turntable_balance_btn_i"><van-icon name="arrow" /></div>

            <div class="turntable_balance_btn_more" id="more" >
              <van-col span="24" class="turntable_balance_btn_more_i" @click="more_btn"><van-icon name="wap-nav" /></van-col>
              <van-col span="24" class="turntable_balance_btn_more_name" @click="more_btn">更多</van-col>
            </div>
          </van-col>

        </van-col>
      </van-col>
    </van-row>
    <van-popup v-model="prize" class="turntable_tips" position="bottom" :style="{ height: '75%' }">
      <van-col span="24" class="turntable_tips_title">恭喜获得</van-col>
      <van-col span="24" :class="reward_list.length === 1 ? 'turntable_tips_center turntable_tips_grid' : 'turntable_tips_center'">
        <van-grid :gutter="15" :column-num="3">
          <van-grid-item v-for="(v,i) in reward_list" :key="i" >
            <van-col span="24" class="mysterious_show_img">
              <img :src="v.img"/>
            </van-col>
            <van-col span="24" >
              <van-col span="24" class="mysterious_show_name"> {{ v.name }} x {{ v.num }}</van-col>
              <van-col span="24" class="mysterious_show_coin">
                <span>{{ v.coin }}{{ diamonds_name }}</span>
              </van-col>
            </van-col>
          </van-grid-item>
        </van-grid>
        <van-col span="18" offset="3" class="turntable_tips_btn" @click="turntable_tips_btn">再转{{ prizeList[active].number[turntable_checked] }}次</van-col>
        <van-col span="24" class="turntable_tips_gift">获得的礼物存放在背包中</van-col>
      </van-col>
    </van-popup>
    <van-popup
      v-model="gift_list_show"
      closeable
      class="gift_log_show"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <van-col span="24" class="gift_log_title">我的中奖记录</van-col>
      <van-col span="24" class="gift_log_type">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="20"
            @load="onLoad"
          >
            <van-cell v-for="item in gift_list" :key="item.id" class="gift_list_li">

              <van-col span="18">
                <van-col span="24" class="gift_list_li_name">
                  {{item. name}} x {{ item.num }}
                </van-col>
                <van-col span="24" class="gift_list_li_time">
                  {{ item.addtime |get_time }}
                </van-col>
              </van-col>
              <van-col span="6" class="gift_log_type_img">
                <img :src="item.img"/>
              </van-col>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-col>
    </van-popup>
    <van-popup
      v-model="turntable_rule"
      closeable
      class="turntable_rule"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <van-col span="24" class="gift_log_title">规则内容</van-col>
      <van-col span="22" offset="1"  class="gift_log_type">
        <v-html v-html="turntable_rule_list"></v-html>
      </van-col>
    </van-popup>
    <van-popup v-model="more_show" get-container="#more" @close="closeClick" class="turntable_rule_log">
      <van-col span="24" class="turntable_rule_btn turntable_rule_status_top" @click="gift_list_show_btn">我的记录</van-col>
      <van-col span="24" class="turntable_rule_btn turntable_rule_status" @click="turntable_rule_btn">游戏规则</van-col>
      <!--   <div class="kailong"></div>-->
    </van-popup>
  </div>
</template>
<script>
import axios from "axios";
import Toast from "vant/lib/toast";
import '@/assets/css/turntable.css'
import '@/assets/css/style.css'
import { judgeIosAndroid } from '@/assets/js/models.js'

const CIRCLE_ANGLE = 360
const config = {
  // 总旋转时间
  duration: 4000,
  // 旋转圈数
  circle: 8,
  mode: 'ease-in-out'
}
export default {
  filters: {
    get_time(time) {
      const d = new Date(parseInt(time) * 1000);
      return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate()) + ' ' +  (d.getHours() > 9 ? d.getHours() : '1' + d.getHours())+":"+(d.getMinutes() > 9 ? d.getMinutes() : '1' + d.getMinutes())+":"+(d.getSeconds() > 9 ? d.getSeconds() : '1' + d.getSeconds())
    }
  },
  data() {
    return {
      more_show: false,
      active: 0,
      turntable_rule_list: {},
      turntable_rule: false,
      refreshing: false,
      loading: false,
      finished: false,
      page:1,
      gift_list_show: false,
      gift_list:[],
      introduce:[],
      coin: 0,
      duration: 3000, // 转盘旋转时间
      turntable_checked: 0,
      prizeList: [], // 奖品列表
      rotateAngle: 30, // 旋转角度
      index: 0,
      prize: false,
      reward_list:[], // 中奖数
      tips: {},
      is_btn: true, // 是否点击状态
      cycling_list: [], // 滚动信息
      room_id: 0,
      diamonds_name: '',
    };
  },
  created() {
    this.room_id = this.$route.query.voice_id
    // 初始化一些值
    this.angleList = []
    // 是否正在旋转
    this.isRotating = false
    // 基本配置
    this.config = config
    // 获取奖品列表
     this.initPrizeList();
  },
  computed: {
    rotateStyle () {
      return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
            transform: rotate(${this.rotateAngle}deg);`
    }
  },
  methods: {
    // 点击选择
    active_onclick(name, title) {
      this.active = name
    },
    turntable_hide () {
      //  拦截关闭跳转
      const isIos = judgeIosAndroid();
      if (isIos == true) {
        // ios传值方法postMessage（val）传值方式
        window.webkit.messageHandlers.closeWebView.postMessage('')
      } else {
        // 传值方法goSubmitted（val）传值方式
        window.AndroidJs.closeWebView('')
      }
    },
    more_btn() {
      this.more_show = true
    },
    closeClick() {
      this.more_show = false
    },
    turntable_rule_btn() {
      const uid = this.$route.query.uid;
      const token = this.$route.query.token;
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=turntable&act=gameplay",{
        params:{
          uid:  uid,
          token:  token
        }
      }).then(res => {
        console.log(res.data)
        if(res.data.status === 1){
          this.turntable_rule_list = res.data.data.post_content
        }
      })
      this.turntable_rule = true
      this.more_show =false
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.page = 1
      this.get_gift_log()
    },
    onLoad() {
      // 异步更新数据
      if(this.page > 1){
        this.get_gift_log()
      }

    },
    get_gift_log(){
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      this.loading = true
      // 获取中奖记录
      const token = this.$route.query.token
      const uid = this.$route.query.uid
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=turntable&act=api_turn_log", {
        params: {
          token: token,
          uid: uid,
          page: this.page
        }
      }).then(res => {
        console.log(res.data)
        const re = res.data
        if(this.page === 1){
          this.gift_list = []
        }
        if(re.status === 1){
          for (let i = 0; i < re.data.length; i++) {
            this.gift_list.push(re.data[i]);
          }
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (re.data.length < 15) {
            this.finished = true;
          }
          console.log(this.gift_list)
          this.page ++
        }else{
          // 加载状态结束
          this.loading = false;
          this.finished = true;
        }
      })
    },
    gift_list_show_btn() {
      this.page = 1
      this.finished = false
      this.get_gift_log()
      this.gift_list_show = true
      this.more_show =false
    },
    turntable_tips_btn() {
      this.prize = false
      this.beginRotate()
    },
    turntable_type_btn(i) {
      this.turntable_checked = i
    },
    //跳转充值页面
    recharge_btn() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({path:'/RechargeRoom',query:{uid:uid, token: token}});
    },
    initPrizeList() {
      // 这里可以发起请求，从服务端获取奖品列表
      // 这里使用模拟数据
      const token = this.$route.query.token
      const uid = this.$route.query.uid
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=turntable&act=api_index", {
        params: {
          token: token,
          uid: uid
        }
      }).then(res => {
        console.log(res.data)
        this.coin = res.data.my_coin
        this.diamonds_name = res.data.diamonds_name
        this.prizeList = res.data.data
        // 计算奖品位置
        this.prizeList[0].gift = this.formatPrizeList(this.prizeList[0].gift)
        this.prizeList[1].gift = this.formatPrizeList(this.prizeList[1].gift)
      })
    },
    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList (list) {
      // 记录每个奖的位置
      const angleList = []
      const l = list.length
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l
      const half = average / 2
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -((i * average) + half) - 10
        // 增加 style
        item.style = `-webkit-transform: rotate(${angle}deg);
                      transform: rotate(${angle}deg);`
        // 记录每个奖项的角度范围
        angleList.push((i * average) + half )
      })
      this.angleList = angleList
      return list
    },
    beginRotate() {
      if(this.is_btn){
        this.is_btn = false
        // 开始抽奖
        // 这里这里向服务端发起请求，得到要获得的奖
        const token = this.$route.query.token
        const uid = this.$route.query.uid
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=turntable&act=lotty_post", {
          params: {
            token: token,
            uid: uid,
            type: this.prizeList[this.active].id,
            num: this.prizeList[this.active].number[this.turntable_checked],
            room_id : this.room_id
          }
        }).then(res => {
          console.log(res.data)
          // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标
          // 随机获取下标
          if(res.data.status === 1) {
            this.coin = res.data.money
            this.reward_list = res.data.data
            this.index = res.data.position
            // 开始旋转
            this.rotating()
          }else{
            this.is_btn = true
            Toast(res.data.error)
          }
        })
      } else {
        Toast('操作太频繁')
      }
    },
    rotating() {
      const { isRotating, angleList, config, rotateAngle, index } = this

      if (isRotating) return

      this.isRotating = true
      // 计算角度
      const angle =
        // 初始角度
        rotateAngle + 10 +
        // 多旋转的圈数
        config.circle * CIRCLE_ANGLE +
        // 奖项的角度
        angleList[index] -
        (rotateAngle % CIRCLE_ANGLE)
      this.rotateAngle = angle
      // 旋转结束后，允许再次触发
      setTimeout(() => {
        this.rotateOver()
      }, config.duration + 1000)
    },
    rotateOver () {
      this.isRotating = false
      this.prize = true
      this.is_btn = true
    }
  }
};
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/turntable.vue